exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".white-text[data-v-c58ad3b8]{color:#fff!important}", ""]);

// exports
